import { Alert } from '@mui/material';
import { isEmpty } from 'lodash';
import { lang } from 'src/utils';

import type { INoResultAlertProps } from './noResultAlert.interface';
import { NoResultContainer } from './NoResultAlert.styled';

export const NoResultAlert = ({
  isLoading = false,
  dataToCheck = undefined,
  message = undefined,
}: INoResultAlertProps) => {
  if (isLoading || !isEmpty(dataToCheck)) {
    return null;
  }

  return (
    <NoResultContainer>
      <Alert severity="warning">{message ? message : lang.noResultText}</Alert>
    </NoResultContainer>
  );
};
